import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import FileService from "../services/file.service";
import * as TbIcons from 'react-icons/tb';
import * as AiIcons from 'react-icons/ai';
import AuthService from "../services/auth.service";
import AxiosService from "../services/axios.service";

const API_PATH = "cases";

function ViewCase({ history, match }) {

  const [lawsuit, setLawsuit] = useState([]);
  const [fileInfos, setFileInfos] = useState([]);
  const { id } = match.params;
  const [mod, setMod] = useState(false);
  const [admin, setAdmin] = useState(false);
  const user = AuthService.getCurrentUser();
  const FILES_URL = "https://db.irli.org:8080/api/files/";

  const styles = {
    div: {
      whiteSpace: "pre-line"
    }
  }

  useEffect(() => {

    if (user) {
      setMod(user.roles.includes("ROLE_MODERATOR"));
      setAdmin(user.roles.includes("ROLE_ADMIN"));
    }
    AxiosService.get(API_PATH, id).then(x => {
      var lawsuit = x.data;
      console.log(lawsuit);
        var str_courts = "";
        var courts = lawsuit.courts
        lawsuit.case_name += lawsuit.case_id ? (", " + lawsuit.case_id) : "";
        for (var i in courts) {
            str_courts += "(" + (courts[i].abbreviation) + ") "; //comma if there is more
        }
        lawsuit.case_name += str_courts ? (", " + str_courts) : str_courts;



      setLawsuit(lawsuit);
      console.log(lawsuit);
      var documents = [];
      documents = lawsuit.documents;
      FileService.getFiles().then((response) => {
        var files = [];
        for (var x in documents) {
          var file = new Object();
          file.name = documents[x];
          file.url = FILES_URL + file.name;
          files.push(file);
        }
        console.log("file infos: " + JSON.stringify(files));
        setFileInfos(files); // previously response.data
      });
    });
  }, []);

  return (

    <div>
      {(mod || admin) && (
        <h1 style={{ marginBottom: 25 }}>{lawsuit.case_name}</h1>
      )}
      <table class="table">
        <div >
          <button style={{ position: 'sticky', left: 0, top: 25, zIndex: 1 }} onClick={() => history.goBack()}><TbIcons.TbArrowBack color='black' size={38} /></button>

        </div>
        <div style={{ position: 'sticky' }}>
          {(mod || admin) && (
            <Link to={`../edit/${id}`} style={{ position: 'relative', left: 0, top: -1, marginTop: 15 }} className="btn btn-sm btn-primary mr-2"> <AiIcons.AiTwotoneEdit size={22} /> </Link>
          )}
        </div>
        <thead>
          <tr>

          </tr>
        </thead>
        <tbody>
          <tr>

            <th scope="row">Case Name:</th>
            {/* {user &&  ( */}
            <td>{lawsuit.case_name}</td>
            {/* )} */}
          </tr>

          <tr>

            <th scope="row">Case ID:</th>
            {/* {user &&  ( */}
            <td>{lawsuit.case_id}</td>
            {/* // )} */}
          </tr>

          <tr>

            <th scope="row">Description:</th>
            {/* {user &&  ( */}
            <td style={styles.div}>
              {lawsuit.description}

            </td>
            {/* )} */}
          </tr>
          <tr>
            <th scope="row">Attorney / Staff Member:</th>
            <td>{lawsuit.staff_member}</td>
          </tr>

          <tr>
            <th scope="row">Status / Next Steps:</th>
            {/* {user &&  ( */}
            <td style={styles.div}>{lawsuit.next_steps}</td>
            {/* )} */}
          </tr>

          <tr>
            <th scope="row">Documents:</th>
            <div className="card">
              {/*<div className="card-header">Documents</div>*/}
              <ul className="list-group list-group-flush">
                {fileInfos && fileInfos.map((file, index) => (
                  <li className="list-group-item" key={index}>
                    <a href={file.url}>{file.name} </a>
                  </li>
                ))}
              </ul>
            </div>
          </tr>

          <tr>
            <th scope="row">Lead Plaintiff Counsel?</th>
            <td style={styles.div}>{lawsuit.lead_counsel}</td>
          </tr>

          <tr>
            <th scope="row">Status</th>
            <td style={styles.div}>{lawsuit.status}</td>
          </tr>

          <tr>
            <th scope="row">Document Type</th>
            <td style={styles.div}>{lawsuit.document_type}</td>
          </tr>

          <tr>
            <th scope="row">Deadline</th>
            <td style={styles.div}>{lawsuit.deadline}</td>
          </tr>

          <tr>
            <th scope="row">Created at</th>
            <td style={styles.div}>{lawsuit.createdAt}</td>
          </tr>

          <tr>
            <th scope="row">Last Updated</th>
            <td style={styles.div}>{lawsuit.updatedAt}</td>
          </tr>

        </tbody>
      </table>
    </div >
  );

}

export { ViewCase };